module.exports = __webpack_public_path__ + "f1d33283f07416f96edd7f5744e81ccf.pdf";